import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IAmbiente,
  ICreateAmbiente,
  IListado,
  IQueryParam,
  IUpdateAmbiente,
} from 'modelos/src';
import { HttpService } from '../../../auxiliares/http.service';
import { HelperService } from '../../../auxiliares/helper.service';
import { apiBase } from '../../../../environments/environment';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class AmbientesService {
  constructor(private http: HttpService) { }

  public listar(queryParams?: IQueryParam): Observable<IListado<IAmbiente>> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/ambientes`, { params });
  }

  public crear(dato: ICreateAmbiente): Observable<IAmbiente> {
    return this.http.post(`${api}/ambientes`, dato);
  }

  public listarPorId(id: string): Observable<IAmbiente> {
    return this.http.get(`${api}/ambientes/${id}`);
  }

  public editar(id: string, dato: IUpdateAmbiente): Observable<IAmbiente> {
    return this.http.put(`${api}/ambientes/${id}`, dato);
  }

  public eliminar(id: string): Observable<void> {
    return this.http.delete(`${api}/ambientes/${id}`);
  }
}
